function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    color: "#f4511e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f4511e"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "244 400 100 256 244 112",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 48
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 256,
    x2: 412,
    y2: 256,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 48
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackRed);
export default __webpack_public_path__ + "static/media/arrow-back-red.a1d4c602b34e068ad3984293115c6ea5.svg";
export { ForwardRef as ReactComponent };